import React from "react";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Tooltip,
  Avatar,
  Button,
  Divider,
  CardMedia,
  Skeleton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import GroupIcon from "@mui/icons-material/Group";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { API_GAME } from "../../../../constants/api";
import FaviconAddUsers from "../../../../assets/images/icons/icon_add_users.svg";
import * as h from "../../../../helpers";
import * as buttonsType from "../../../../constants/buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as kApi from "../../../../constants/api";
import AButtonGamePlay from "../AButtonGamePlay/AButtonGamePlay";
import RoundedButton from "../../../../components/Buttons/RoundedButton";
import AudioPlayer from "../../../../components/AudioPlayer";
import { useTranslation } from "react-i18next";
import DifficultyBadge from "features/NewActivities/DifficultyBadge/DifficultyBadge";
import AMedalStatus from "features/NewActivities/AMedalStatus/AMedalStatus";
import InfoActivitiesPDF from "../infoActivitiesPDF/infoActivitiesPDF";
import FavoriteButton from "features/NewActivities/FavoriteActivities/FavoriteButton/FavoriteButton";
import { useActivities } from "context/ActivitiesContext";
import { useUserAccountInfos } from "hooks/useUserInfos";

const InfoActivitiesContent = ({
  activity,
  modalRef,
  medal,
  openMedal,
  setOpenMedal,
  infoActivity,
  setOpenGame,
  setInfoActivity,
  getRecommendedActivity,
  setOpenState,
  setTaskActivity,
  openFavoriteMessage,
  handleFavorited,
  hideFavoriteButton = false,
  isQuiz = false,
}) => {
  // const [medalStatus, setMedalStatus] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [audioAnswers, setAudioAnswers] = useState(false);
  const { t } = useTranslation();
  const [loadingPdf, setLoadingPdf] = useState(false);
  const infoSectionRef = useRef(null);
  //Estado que controla as atividades favoritadas
  const [isFavorited, setIsFavorited] = useState(activity.favorited);
  const { session } = useSelector((state) => state.session);
  const { data: myUser } = useUserAccountInfos();

  const { tasks } = useSelector((state) => state.tasks);
  const { setOpenGameIsQuiz } = useActivities();

  // Indica se a atividade atual já existe na lista de tarefas
  const isTaskAlreadyAdded =
    Array.isArray(tasks) &&
    tasks.some((task) => Number(task.game_id) === Number(activity.id));

  useEffect(() => {
    if (openMedal) {
      modalRef.current.nextModal(1);
    }
  }, [openMedal]);

  const handleAddTask = (activity) => {
    setOpenState(false);
    setTaskActivity(activity);
  };

  const handleImageLoad = () => setImageLoaded(true);

  //? Função do botão de favoritar
  const handleToggleFavorite = () => {
    handleFavorited(activity, !activity.favorited);
    setIsFavorited(!isFavorited); // Alterar o status de favorito
    openFavoriteMessage(activity); // Chama a função passada como prop
  };

  //? Função que lida com o clique em uma atividade recomendada
  const handleRecommendedClick = (activity) => {
    // Busca a atividade recomendada com base no ID
    const newRecomend = getRecommendedActivity(activity);

    // Se encontrar pelo menos uma atividade correspondente
    if (newRecomend.length > 0) {
      // Define a atividade como a selecionada para exibir as informações
      setInfoActivity(newRecomend[0]);

      // Rola suavemente até a seção de informações
      scrollToInfoSection();
    }
  };

  const handleOpenGame = (game, type) => {
    setOpenGame(game);
    setOpenGameIsQuiz(type);
  };

  //? Função que faz a rolagem suave até a seção de informações
  const scrollToInfoSection = () => {
    setTimeout(() => {
      infoSectionRef.current?.scrollIntoView({
        behavior: "smooth", // Animação de rolagem suave
        block: "start", // Alinha o topo da seção ao topo da tela
      });
    });
  };

  //? Renderização dos botões para áudio e jogo
  const ActivityButton = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {activity.type === "audio" ? (
          <Grid item size={{ xs: 12 }}>
            <Box>
              <AudioPlayer
                center
                disable={false}
                marginBottom
                id={activity.id}
                name={activity.name}
                url_audio={kApi.GET_API_AUDIO_URL(activity)}
              />
              {session && myUser?.typeUser != "patient_free" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "16px",
                  }}
                >
                  {/* //tem q colocar uma prop para se tem pdf ou nao no back */}

                  <RoundedButton
                    testId="infoActivitiesAudio_downloadPdf_btn"
                    onClick={() =>
                      h.openExternalLink(
                        API_GAME + "/" + infoActivity.path + "/gabarito.pdf",
                      )
                    }
                    text={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {t("global.download")}
                        <FontAwesomeIcon icon={faFileDownload} />
                      </span>
                    }
                    size={buttonsType.BTN_SIZE_MD}
                  />

                  <RoundedButton
                    // onClick={() => modalRef.current.nextModal(2)}
                    onClick={() => {
                      setLoadingPdf((pdfStatus) => !pdfStatus);
                      setAudioAnswers((audioStatus) => !audioStatus);
                    }}
                    testId={`infoActivitiesAudio_${
                      audioAnswers ? t("closeAnswer") : t("showAnswer")
                    }_btn`}
                    text={
                      audioAnswers
                        ? t("global.close_audio_answer")
                        : t("global.show_audio_answer")
                    }
                    size={buttonsType.BTN_SIZE_MD}
                    style={{ width: "138", height: "44px" }}
                  />
                </Box>
              )}
            </Box>
          </Grid>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              alignSelf: "flex-end",
              gap: "10px",
              // marginRight: "25px",
            }}
          >
            {/* Botão Jogar */}
            <AButtonGamePlay onClick={() => handleOpenGame(activity, isQuiz)} />
            {session &&
            myUser?.typeUser != "patient_free" &&
            setTaskActivity &&
            !isTaskAlreadyAdded ? (
              <>
                {/* Mostra o botão apenas se a atividade ainda não for uma task */}
                <Tooltip title="Usuários">
                  <Avatar
                    data-testid="modalInfoActivities_users_btn"
                    onClick={() => {
                      handleAddTask(activity);
                    }}
                    src={FaviconAddUsers}
                    sx={{
                      bgcolor: "#E6E6E6",
                      color: "primary.dark",
                      width: 39,
                      height: 39,
                      cursor: "pointer",
                      position: "relative",
                      top: "-6px",
                    }}
                  >
                    <GroupIcon fontSize="small" />
                  </Avatar>
                </Tooltip>
              </>
            ) : null}
            {session && myUser?.typeUser != "patient_free"
              ? !hideFavoriteButton && (
                  <Box sx={{ marginBottom: "10px" }}>
                    <FavoriteButton
                      favorited={isFavorited}
                      onClick={handleToggleFavorite}
                    />
                  </Box>
                )
              : null}
          </Box>
        )}
      </Box>
    );
  };

  //? Mapear as informações de cada jogo e renderizar
  const activityInfos = () => {
    const isAudio = activity.type === "audio";
    return (
      <Grid item size={{ xs: 12, md: 8 }}>
        <Box sx={{ maxWidth: "650px" }}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: activity.infos }}
            sx={{
              "& strong": { fontSize: "16px" },
              "& p": {
                marginBottom: "16px",
                fontSize: "15px",
                fontWeight: "400",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",

                "@media (max-width: 720px)": {
                  fontSize: "13px",
                },
              },
              ...(isAudio && {
                "& p": {
                  "@media (max-width: 720px)": {
                    fontSize: "13px",
                  },
                },
              }),
            }}
          />
        </Box>
      </Grid>
    );
  };

  // //? Renderizar atividades semelhantes
  const SimilarActivity = ({ activity }) => {
    const [similarImageLoaded, setSimilarImageLoaded] = useState(false);
    if (
      !activity?.related_activities_list ||
      activity.related_activities_list.length === 0
    ) {
      return <Typography>Sem atividades semelhantes.</Typography>;
    }

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: { xs: "8px", sm: "14px", md: "12px", lg: "16px" },
          justifyContent: "center",
          overflow: "hidden",
          width: "100%",
          height: "auto",
          background: !similarImageLoaded ? "#f0f0f0" : "transparent",
        }}
      >
        {activity.related_activities_list.slice(0, 4).map((item, index) => (
          <Box
            key={index}
            onClick={() => handleRecommendedClick(item)}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              width: {
                xs: "45%",
                sm: "45%",
                md: "23%",
                lg: "22%",
                xl: "20%",
              },
            }}
          >
            <CardMedia
              component="img"
              width="100%"
              height="auto"
              onLoad={() => setSimilarImageLoaded(true)}
              image={item.url}
              alt={item.gameName || "Atividade"}
              sx={{
                display: similarImageLoaded ? "block" : "none",
                borderRadius: "10px",
              }}
            />
          </Box>
        ))}
      </Box>
    );
  };

  //? Função para retornar as informações de créditos
  const getCreditInformation = (activity) => {
    if (activity?.credits) {
      const typeDescriptionMap = {
        elaboration: { description: t("global.elaboration") },
        development: { description: t("global.development") },
        illustration: { description: t("global.illustration") },
      };

      return Object.keys(activity.credits).map((type) => {
        const { description } = typeDescriptionMap[type] || {
          description: "Descrição não disponível",
        };
        return (
          <Box
            key={type}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "10px",
              marginTop: "20px",

              "@media (max-width: 1024px)": {
                alignItems: "flex-start",
                textAlign: "left",
              },

              "@media (max-width: 720px)": {
                marginBottom: "5px",
                marginTop: "10px",
                alignItems: "flex-start",
                textAlign: "left",
              },
            }}
          >
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{
                textTransform: "uppercase",
                fontSize: "13px",
                fontWeight: "600",
                color: "#4d4d4d",
                marginRight: 2,

                "@media (max-width: 720px)": {
                  marginRight: 0,
                },
              }}
            >
              {description}
            </Typography>
            {activity.credits[type].map((credit, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: "14px",
                  fontWeight: "300",
                  color: "#4d4d4d",

                  "@media (max-width: 720px)": {
                    fontSize: "12px",
                  },
                }}
              >
                {credit}
                <br />
              </Typography>
            ))}
          </Box>
        );
      });
    }
    return null;
  };

  //? Função para retornar as imagens
  const imageUrl =
    activity && activity.type
      ? (activity?.type).toLowerCase() === "jogo"
        ? `${API_GAME}/${activity?.path}/jogo_imagem_.jpg`
        : `${API_GAME}/${activity?.path}/audio_imagem_.jpg`
      : "";

  return (
    <Box
      ref={infoSectionRef}
      sx={{
        height: "714px",
      }}
    >
      {/* Conteúdo principal do modal */}
      <Grid
        container
        spacing={1}
        sx={{ flexDirection: { xs: "column", md: "row" } }}
      >
        <Grid item size={{ xs: 12, md: loadingPdf ? 8 : 7 }}>
          {loadingPdf && (
            <InfoActivitiesPDF
              modalRef={modalRef}
              infoActivity={infoActivity}
            />
          )}
          {/* Renderiza informações da atividade */}
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
              fontSize: "15px",
              fontWeight: "300",
              textAlign: "left",
              marginLeft: "20px",
              order: { xs: 2, md: 1 },
            }}
          >
            {activityInfos()}
          </Typography>
        </Grid>
        {/* Imagem e botões (lado direito) */}

        <Grid
          item
          size={{ xs: 12, md: loadingPdf ? 4 : 5 }}
          sx={{
            margin: "0 auto",
            maxWidth: "1200px",
            padding: "0 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            order: { xs: -1, md: 2 },
            overflowX: "hidden",
          }}
        >
          {/* Card da imagem lateral */}
          {!imageLoaded && (
            <Skeleton variant="rectangular" width={332} height={190} />
          )}
          <Box
            component="img"
            onLoad={handleImageLoad}
            src={imageUrl}
            sx={{
              display: imageLoaded ? "block" : "none",
              borderRadius: "12px",
              width: "332px",
            }}
          />
          {/*Botões abaixo da imagem*/}
          <Box
            sx={{
              marginTop: "27px",
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
              marginRight: "8px",
            }}
          >
            {ActivityButton()}
          </Box>
          {/* Renderiza informações adicionais, como dificuldade */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
              gap: 1,
              width: "317px",
              height: "117px",
              border: "1px solid #E8E8E8 ",
              borderRadius: "12px",
              padding: "8px",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          >
            {/* Dificuldade e Conquistas */}
            <Box sx={{ marginBottom: "25px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  color: "#595959",
                  marginBottom: "10px",
                }}
              >
                Dificuldade
              </Typography>
              <DifficultyBadge activity={activity} />
            </Box>
            {activity.type === "jogo" && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    color: "#595959",
                    marginBottom: "10px",
                  }}
                >
                  Conquistas
                </Typography>
                {medal && (
                  <Box onClick={() => setOpenMedal(medal)}>
                    <AMedalStatus medal={medal} />
                  </Box>
                )}
              </Box>
            )}
            {activity.type === "audio" &&
              session &&
              myUser?.typeUser != "patient_free" &&
              !isTaskAlreadyAdded && (
                <>
                  <Button
                    data-testid="modalInfoActivities_users_btn"
                    sx={{
                      padding: 0,
                      minWidth: "auto",
                      height: "39px",
                      width: "39px",
                      borderRadius: "50%",
                    }}
                  >
                    <Tooltip title="Usuários">
                      <Avatar
                        onClick={() => {
                          handleAddTask(activity);
                        }}
                        src={FaviconAddUsers}
                        sx={{
                          bgcolor: "#E6E6E6",
                          color: "primary.dark",
                          width: 39,
                          height: 39,
                          cursor: "pointer",
                          position: "relative",
                          top: "-6px",
                        }}
                      >
                        <GroupIcon fontSize="small" />
                      </Avatar>
                    </Tooltip>
                  </Button>
                </>
              )}
            {activity.type === "audio" &&
              session &&
             myUser?.typeUser != "patient_free" &&
              !hideFavoriteButton && (
                <Box sx={{ marginBottom: "10px" }}>
                  <FavoriteButton
                    favorited={isFavorited}
                    onClick={handleToggleFavorite}
                  />
                </Box>
              )}
          </Box>
        </Grid>
      </Grid>
      {session && myUser?.typeUser !== "patient" && (
        <Grid>
          <Divider
            style={{
              marginTop: "8px",
              marginBottom: "16px",
              border: "none",
              width: "100%",
              height: "1px",
              background: "rgba(0, 0, 0, 0.16)",
            }}
          />
          <Typography
            variant="h6"
            mt={4}
            sx={{
              fontSize: "19px",
              fontWeight: "500",
              lineHeight: "29px",
              color: "#662D91",
              position: "relative",
              padding: "0 10px",
              marginBottom: "20px",
            }}
          >
            Atividades Semelhantes
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "26px",
              flexWrap: "wrap",
              maxWidth: "100%",

              "@media (max-width: 720px)": {
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              },
            }}
          >
            <SimilarActivity activity={activity} />
          </Box>
        </Grid>
      )}
      <Box
        sx={{
          marginTop: "40px",
        }}
      >
        <Divider
          style={{
            marginTop: "8px",
            marginBottom: "16px",
            border: "none",
            width: "100%",
            height: "1px",
            background: "rgba(0, 0, 0, 0.16)",
          }}
        />
        {/* Renderiza informações da atividade */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",

            "@media (max-width: 720px)": {
              flexDirection: "column",
              alignItems: "flex-start",
            },
          }}
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
              marginLeft: 3,
              display: "inline-flex",
              gap: "16px",

              "@media (max-width: 720px)": {
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
                textAlign: "left",
              },
            }}
          >
            {getCreditInformation(activity)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoActivitiesContent;
